import iView from 'iview'
import store from '@/store'
import router from "@/router";
// import {indexRouter} from '@/config'
// import { getToken } from '@/utils'
//修改loadingBar-color
iView.LoadingBar.config({
  color: '#fefa01'
})

function removeQueryParam(
  paramKey,
  path,
  query,
) {
  const newQuery = { ...query, [paramKey]: undefined };
  const { [paramKey]: _, ...rest } = newQuery;
  router.push({
    path,
    query: rest,
  });
}

export const routerBeforeEach = function (to, from, resolve) {
  if (to.name === '401') {
    store.commit('PRE_URL', from.fullPath)
    resolve()
  }
  console.log('to.query===[routerBeforeEach]',to.query)
  if (to.query.access_token) {
    sessionStorage.setItem('token', to.query.access_token)
    localStorage.setItem('token', to.query.access_token)
    removeQueryParam('access_token', to.path, to.query)
  }
  // const token = getToken()
  const crumbsList = store.state.crumbsList
  let routes = crumbsList.length ? crumbsList : JSON.parse(sessionStorage.crumbsList || '[]')
  //未登录状态，重定向到登录
  // if ((!token && to.name !== 'login')) {
  //   resolve('/')
  //   return
  // } else

  //验证token
  // if (token && to.name === 'login') {
  //   //未登录状态，重定向到首页
  //   resolve({
  //     name: indexRouter
  //   })
  //   return
  // }
  // 检查是否使用window.open
  if (to.meta.open && !from.meta.open && from.fullPath !== '/' && window.name !== to.fullPath) {
    window.open(`#${to.fullPath}`, to.fullPath)
    return
  }
  let index = routes.findIndex(item => item.name === to.name)
  //如果index为最后一个，视为缓存，暂不处理
  if (to.name !== 'index' && to.name !== 'login') {
    if (routes.length && index === routes.length - 1) {
      store.commit('CRUMBS_LIST', routes.length ? [...routes.slice(0, index), Object.assign({}, routes[index], {
        query: to.query
      })] : routes)
    } else if (index < 0) { //新增
      if (to.meta.isFirstPage) {
        routes = []
      }
      store.commit('CRUMBS_LIST', routes.concat({
        name: to.name,
        title: to.meta.title,
        query: to.query
      }))
    } else {
      if (index === 0) {
        store.commit('CRUMBS_LIST', [routes[0]])
      } else {
        store.commit('CRUMBS_LIST', [...routes.slice(0, index)])
      }
    }
  } else {
    routes = []
    store.commit('CRUMBS_LIST', routes)
  }
  sessionStorage.setItem('crumbsList', JSON.stringify(store.state.crumbsList))
  iView.LoadingBar.start()
  resolve()
}
export const routerAfterEach = function (to, from) {
  iView.LoadingBar.finish()
}
